import { createAction, props } from '@ngrx/store'
import { RankedMetric, RankingContext } from '../../models/ranking.model'
import { ComparableMetric, ListedMetric } from '@core/models/metric.models'
import { ContextMenuItemEvent } from '@core/models/context-menu.models'
import { Aggregation } from '@features/aggregations/models/aggregations.models'

export const openRankingWarningModal = createAction('[Rankings] open warning modal', props<{ body: string }>())

export const performFetchRanking = createAction(
  '[Rankings] perform fetch ranking',
  props<{ payload: ContextMenuItemEvent }>()
)

export const openRankingModal = createAction('[Rankings] open modal', props<{ payload: RankingContext }>())

export const closeRankingModal = createAction('[Rankings] close modal')

export const fetchRanking = createAction('[Rankings] fetch ranking', props<{ payload: ContextMenuItemEvent }>())

export const refreshRanking = createAction('[Rankings] refresh ranking', props<{ aggregation: Aggregation }>())

export const setRankingSourceMetric = createAction(
  '[Rankings] set source metric',
  props<{ sourceMetric: ListedMetric | ComparableMetric }>()
)

export const setRanking = createAction('[Rankings] set ranking', props<{ ranking: RankedMetric[] }>())
export const setRankingLoader = createAction('[Rankings] set ranking loader', props<{ loading: boolean }>())

export const setRankingContext = createAction('[Rankings] set ranking context', props<RankingContext>())

export const setRankingMatchDay = createAction('[Rankings] set ranking match day', props<{ matchDay: number }>())

export const purgeRanking = createAction('[Rankings] purge ranking')
